import React from 'react';
import { Moon, Activity, Brain, Pill } from 'lucide-react';
import { Divider } from './ui/Divider';
export function IdentificationSection() {
  const painPoints = [{
    icon: <Moon className="w-6 h-6" data-id="element-23" />,
    text: 'You wake up at 3:00 AM with your mind racing and your skin hot.'
  }, {
    icon: <Activity className="w-6 h-6" data-id="element-24" />,
    text: 'Your jeans won\'t button despite eating "clean" and working out.'
  }, {
    icon: <Brain className="w-6 h-6" data-id="element-25" />,
    text: 'The "Brain Fog" makes you feel like you\'re losing your edge at work or at home.'
  }];
  return <section className="bg-sage-light py-24 px-6" data-id="element-26">
      <div className="max-w-4xl mx-auto" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6" data-id="element-29">
            If you are between the ages of 35 and 60, you know the feeling:
          </h2>
          <Divider data-id="element-30" />
        </div>

        <div className="space-y-8 mb-16" data-id="element-31">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-6 bg-cream p-8 rounded-2xl shadow-sm border border-sage/10 transition-transform duration-300 hover:-translate-y-1" data-id="element-32">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-sage/20 flex items-center justify-center text-olive-gold" data-id="element-33">
                {point.icon}
              </div>
              <p className="text-lg md:text-xl text-warm-dark pt-2 leading-relaxed" data-id="element-34">
                {point.text}
              </p>
            </div>)}
        </div>

        <div className="bg-olive-gold text-cream p-8 md:p-10 rounded-2xl text-center relative overflow-hidden" data-id="element-35">
          <div className="absolute top-0 left-0 w-full h-1 bg-olive-light" data-id="element-36"></div>
          <Pill className="w-10 h-10 mx-auto mb-6 opacity-80" data-id="element-37" />
          <p className="text-xl md:text-2xl font-heading italic leading-relaxed" data-id="element-38">
            Traditional medicine tells you it's "just aging." They offer you
            antidepressants or hormone patches for symptoms, but they never fix
            the root cause.
          </p>
        </div>
      </div>
    </section>;
}